module.exports = __webpack_public_path__ + "f2bd9ce1f2b5dbc6639fc7a439ef41a1.fbx";